import { gql, type TypedDocumentNode } from "@apollo/client";
import type { InteractionTopicConfig, InteractionTopicInput } from "./queries";

export type UpdateInteractionTopicConfigResponse = {
  updateInteractionTopicConfig: {
    success: boolean;
    message: string;
    config?: InteractionTopicConfig | null;
  };
};

export type UpdateInteractionTopicConfigVariables = {
  input: {
    department: string;
    topics: InteractionTopicInput[];
    lockVersion?: number;
  };
};

export const UPDATE_INTERACTION_TOPIC_CONFIG_MUTATION: TypedDocumentNode<
  UpdateInteractionTopicConfigResponse,
  UpdateInteractionTopicConfigVariables
> = gql`
  mutation UpdateInteractionTopicConfig($input: BackofficeUpdateInteractionTopicConfigInput!) {
    updateInteractionTopicConfig(input: $input) {
      success
      message
      config {
        department
        lockVersion
        topics {
          name
          description
          subtopics {
            name
            description
          }
          code
          defaultPrivate
        }
      }
    }
  }
`;
